export default "__VITE_ASSET__Te3ATdL$__"